export const linkToAppStore =
  'https://itunes.apple.com/app/tourstart/id586049610?mt=8';
export const linkToGooglePlay =
  'https://play.google.com/store/apps/details?id=org.tourstart';
export const linkToFb = 'https://www.facebook.com/Tourstart/';
export const lintToFbDk = 'https://www.facebook.com/tourstartdk/';
export const linkToYoutube = 'https://www.youtube.com/@Tourstart';
